/**
 * @description Manages a store object
 */
export class DataStore {
  /**
   * @description Creates a new instance of the DataStore class
   * @param {object} store An object which will be used as a storage
   * @param {function} serializer A serializer function
   * @param {function} deserializer A deserializer function
   */
  constructor( store, serializer, deserializer ) {
    this.store = store;
    this.serializer = serializer && serializer.apply ? serializer : x => x;
    this.deserializer = deserializer && deserializer.apply ? deserializer : x => x;
  }

  /**
   * @description Gets the stored data for the specified key
   * @param {string} key A key, which was used store the data
   * @returns {object} Returns the stored Data for the specified key
   */
  get( key ) {
    const val = this.store.getItem( key + '_' + this.getKey() );
    if ( !val ) {
      return val;
    }
    try {
      return this.deserializer( val );
    } catch ( ex ) {
      console.error( `Couldn't deserialize: ${key} with value ${val}. Exception: ${ex}` );
      return null;
    }
  }

  /**
   * @description Stores the data, which can be accessed by using the key
   * @param {string} key A key, which allows to access the data
   * @param {object} value The data, which should be stored
   */
  set( key, value ) {
    this.store.setItem( key + '_' + this.getKey(), this.serializer( value ) );
  }

  /**
   * @description Removes the stored data for the specified key
   * @param {string} key A key, which was used store the data
   */
  remove( key ) {
    this.store.removeItem( key + '_' + this.getKey() );
  }

  /**
   * @description Removes all data
   */
  clear() {
    this.store.clear();
  }

  getKey() {
    return btoa( window?.location?.href?.split('//')[1].split('#')[0]);
  }
}